import type { UseWidget } from '@swf/core/hooks/useWidget';
import { useWidget } from '@swf/core/hooks/useWidget';
import type { WidgetModelConfig } from '@swf/core/store';
import type { PageData } from '@swf/core/types/Poker';
import { PKR_INITIAL_STATE } from '@swf/poker';

import effects from './effects';
import {
  clubInfo,
  gameSelect,
  joinGame,
  leaveGame,
  loading,
  reset,
  userClubs,
  userClubsAndGames
} from './reducers';
import selectors from './selectors';

const reducers = {
  clubInfo,
  gameSelect,
  joinGame,
  leaveGame,
  loading,
  reset,
  userClubsAndGames,
  userClubs
};

export interface HomeGamesWidgetModel extends WidgetModelConfig<void, PageData> {
  reducers: typeof reducers;
  effects: typeof effects;
  selectors: typeof selectors;
}

export const homeGamesWidgetModel: HomeGamesWidgetModel = {
  state: PKR_INITIAL_STATE,
  reducers,
  effects,
  selectors
};

export const useHomeGamesWidget: UseWidget<void, HomeGamesWidgetModel> = useWidget;
